'use client';

import { useEffect, useState } from 'react';

import { useArticleBannerQuery } from '@/entities/article';
import TopBanner from '@/features/TopBanner';

interface ShowArticleBannerProps {
  newsId: number;
}

const ShowArticleBanner = ({ newsId }: ShowArticleBannerProps) => {
  const { data } = useArticleBannerQuery({ newsId });
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBanner(window.scrollY > 116);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!data) {
    return null;
  }

  const { title, linkText, link, backgroundColor, image } = data;
  const isDataEmpty =
    !title || !linkText || !link || !backgroundColor || !image;

  if (isDataEmpty) {
    return null;
  }

  return (
    <TopBanner
      imageUrl={image ?? ''}
      title={title ?? ''}
      link={link}
      linkText={linkText ?? ''}
      backgroundColor={backgroundColor ?? ''}
      className={
        showBanner
          ? 'translate-y-0 bg-opacity-100 opacity-100'
          : '-translate-y-full opacity-0'
      }
    />
  );
};

export default ShowArticleBanner;
